import { queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarFacturasDeSolicitud } from "../services/facturas.api";
import { intervaloRefrescoFacturas } from "../utils/facturas-de-solicitud";

/**
 * Facturas de UNA solicitud (acuse más reciente por UUID) · carga PEREZOSA: el
 * consumidor la monta solo al expandir la fila, así que la petición sale hasta
 * entonces. Refresca cada 10 s solo mientras alguna factura siga "En proceso".
 */
export const facturasDeSolicitudQueryOptions = (solicitudId: string) =>
  queryOptions({
    queryKey: qk.facturasDeSolicitud(solicitudId),
    queryFn: () => listarFacturasDeSolicitud(solicitudId),
    staleTime: 30_000,
    refetchInterval: (query) => intervaloRefrescoFacturas(query.state.data),
  });

export function useFacturasDeSolicitud(solicitudId: string) {
  return useQuery(facturasDeSolicitudQueryOptions(solicitudId));
}
